import { z } from "zod";

import { api } from "@/redux/api";

export const PositiveReplyTrackingSchema = z.object({
	enabled: z.boolean(),
	trackerListId: z.number().nullable(),
	trackerListName: z.string().nullable(),
});

export type PositiveReplyTracking = z.infer<typeof PositiveReplyTrackingSchema>;

export interface UpdatePositiveReplyTrackingBody {
	enabled?: boolean;
	trackerListId?: number | null;
}

/**
 * The account-wide switch for adding positively replying leads to a Profile Tracker
 * (PREC-3417).
 *
 * Its own route rather than a field on the company update, because that endpoint requires a
 * company name — a toggle should not have to resend the whole company to save itself.
 */
export const positiveReplyTrackingApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getPositiveReplyTracking: builder.query<PositiveReplyTracking, void>({
			query: () => ({
				url: "positive-reply-tracking",
				responseSchema: PositiveReplyTrackingSchema,
			}),
			providesTags: ["PositiveReplyTracking"],
		}),
		updatePositiveReplyTracking: builder.mutation<
			PositiveReplyTracking,
			UpdatePositiveReplyTrackingBody
		>({
			query: (body) => ({
				url: "positive-reply-tracking",
				method: "PATCH",
				body,
				responseSchema: PositiveReplyTrackingSchema,
			}),
			invalidatesTags: ["PositiveReplyTracking"],
		}),
	}),
});

export const { useGetPositiveReplyTrackingQuery, useUpdatePositiveReplyTrackingMutation } =
	positiveReplyTrackingApi;
